module.exports = __webpack_public_path__ + "assets/img/warrior-name-23f3fdd4.png";